export default class {
  constructor($uibModalInstance, view) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.view = view || { name: 'The current view'};
  }

  overwrite() {
    this.$uibModalInstance.close();
  }
  cancel() {
    this.$uibModalInstance.dismiss();
  }
}